// src/components/landing/AffiliationsSection.jsx
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import img_affiliation_kpsc from '../../assets/images/landing/affiliation-kpsc.jpg';
import img_affiliation_national from '../../assets/images/landing/affiliation-national.jpg';
import img_affiliation_office from '../../assets/images/landing/affiliation-office.jpg';
const AFFILIATIONS = [
  {
    img: img_affiliation_national,
    title: 'National Development Agency',
    text: 'IT division of Bharat Sevak Samaj, The National Development agency established in 1952 by Planning Commission, Govt. of India.',
    accent: 'linear-gradient(90deg,#ef4444,#f97316)',
  },
  {
    img: img_affiliation_kpsc,
    title: 'Govt. of Kerala Approved DCA',
    text: 'DCA course certificate approved by the Govt of Kerala for suitable posts in KPSC.',
    accent: 'linear-gradient(90deg,#10b981,#06b6d4)',
  },
  {
    img: img_affiliation_office,
    title: 'MS Office Equivalence',
    text: 'MS Office Certificate equivalent to KGTE Computer Word Processing for LD Typist roles.',
    accent: 'linear-gradient(90deg,#3b82f6,#8b5cf6)',
  },
];

export default function AffiliationsSection() {
  return (
    <Box id="affiliations" sx={{ bgcolor: '#f8faff', py: { xs: 8, md: 12 }, px: { xs: 3, md: 8 } }}>
      <Box sx={{ textAlign: 'center', mb: 7 }}>
        <Typography sx={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#1d6cf0', mb: 1.5 }}>
          Recognition
        </Typography>
        <Typography sx={{ fontSize: { xs: '1.7rem', md: '2.4rem' }, fontWeight: 900, letterSpacing: '-0.5px', color: '#1e293b', mb: 1.5 }}>
          Recognized Everywhere
        </Typography>
      </Box>

      <Grid container spacing={3} sx={{ maxWidth: 1040, mx: 'auto' }}>
        {AFFILIATIONS.map((a, i) => (
          <Grid item xs={12} md={4} key={a.title}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              style={{ height: '100%' }}
            >
              <Box sx={{
                bgcolor: '#fff', border: '1px solid #e2eaf5',
                borderRadius: 5.5, overflow: 'hidden', height: '100%',
                boxShadow: '0 4px 20px rgba(29,108,240,0.07)',
                transition: 'transform 0.3s, box-shadow 0.3s',
                '&:hover': { transform: 'translateY(-8px)', boxShadow: '0 20px 50px rgba(29,108,240,0.15)' },
              }}>
                <Box sx={{ height: 4, background: a.accent }} />
                <Box sx={{ height: 180, overflow: 'hidden' }}>
                  <Box component="img" src={a.img} alt={a.title}
                    sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block',
                      transition: 'transform 0.4s', '&:hover': { transform: 'scale(1.04)' } }} />
                </Box>
                <Box sx={{ p: 3.5 }}>
                  <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#1e293b', mb: 1 }}>{a.title}</Typography>
                  <Typography sx={{ fontSize: '0.85rem', color: '#64748b', lineHeight: 1.65 }}>{a.text}</Typography>
                </Box>
              </Box>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
